import React, { Component } from 'react';
import { Box, Button, Card, Flex, Heading } from 'core/components';
import { observer } from 'mobx-react';
import DataViewWrapper from 'app/components/dataviews/DataViewWrapper';
import { ViewInExplorerButton } from 'app/components/dataviews/tools';
import Legend from 'app/components/dataviews/views/legend/Legend';

@observer
class SyslogToolResult extends Component {
  render() {
    const { tool, onDataViewCreate, onCloseToolResult, onQueryError } = this.props;

    // Ensure tool and query_object exist before rendering DataViewWrapper
    if (!tool || !tool.query_object) {
      return <Flex>Invalid tool data for Syslog.</Flex>;
    }

    return (
      <Card
        className="tool-result-syslog"
        display="flex"
        flexDirection="column"
        gap={2}
        minHeight={750}
        height="100%"
        overflow="hidden"
      >
        <Flex alignItems="center" justifyContent="space-between" p={2} pb={0}>
          <Heading level={5} m={0} flex={1}>
            {tool.title}
          </Heading>
          <Flex alignItems="center" gap={1}>
            <ViewInExplorerButton query={tool.query_object} openInNewWindow text="View in Data Explorer" />
            <Button text="Close" small icon="cross" onClick={() => onCloseToolResult(tool)} color="muted" minimal />
          </Flex>
        </Flex>

        <DataViewWrapper
          key="dataview"
          query={tool.query_object}
          allowCache
          onDataViewCreate={onDataViewCreate}
          headerProps={{
            showTitle: false,
            showTitleLink: false,
            showViewTypeTag: true,
            shouldArrangeVertically: false,
            showLastUpdated: false,
            showDateRange: true,
            showAppliedFilters: true,
            showDataSources: true,
            isDashboardView: true // makes the title size smaller
          }}
          fitToHeight
          viewProps={{
            showNativeLegend: false,
            hasFooter: true,
            height: 200 // Use a fixed height for the chart
          }}
        >
          {({ component, header, dataview, dataViewConfig }) => {
            if (dataview.errors.length > 0 && onQueryError) {
              onQueryError(dataview.errors);
            }

            const { showLegend } = dataViewConfig;
            return (
              <>
                <Box px={2} mt={-2} mb={1}>
                  {header}
                </Box>

                {component}
                {showLegend && dataview && <Legend dataview={dataview} includeTotalRow={false} />}
              </>
            );
          }}
        </DataViewWrapper>
      </Card>
    );
  }
}

export default SyslogToolResult;
